import React from "react";
const InputError = ({ children }) => {
  return <div className="py-2 error-message">{children}</div>;
};
export default InputError;
